/* eslint-disable import/prefer-default-export */
import initializeCampaignTracker from './initializeCampaignTracker';

setTimeout(initializeCampaignTracker, 1000);

export {
  initializeCampaignTracker,
};
